webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(41);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var state = {
    score: 0,
    bestScore: 0
};
var getters = {
    score: function score(state) {
        return state.score;
    }
};
var actions = {
    save: function save(_ref) {
        var commit = _ref.commit;

        commit('saveState');
    },
    init: function init(_ref2) {
        var commit = _ref2.commit;

        commit('init');
    }
};
var mutations = {
    addScore: function addScore(state, score) {
        state.score += score;
        if (state.score > state.bestScore) {
            state.bestScore = state.score;
        }
    },
    saveState: function saveState(state) {
        console.log(state);
        localStorage.setItem('state', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
    },
    init: function init(state) {
        var savedState = JSON.parse(localStorage.getItem('state'));
        if (savedState) {
            var score = savedState.score,
                bestScore = savedState.bestScore;

            state.score = score;
            state.bestScore = bestScore;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(35),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_main_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_gamehead__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_gamehead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_gamehead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_gamecontainer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_gamecontainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_gamecontainer__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        gamehead: __WEBPACK_IMPORTED_MODULE_1__components_gamehead___default.a,
        gamecontainer: __WEBPACK_IMPORTED_MODULE_2__components_gamecontainer___default.a

    }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            cells: 16
        };
    }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grid__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tiles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tiles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tiles__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        grid: __WEBPACK_IMPORTED_MODULE_0__grid___default.a,
        tiles: __WEBPACK_IMPORTED_MODULE_1__tiles___default.a
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__row__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__row__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tileslength: 16,
            tiles: [],
            oldTiles: [],
            moved: false,
            over: false,
            map: {
                38: 0,
                39: 1,
                40: 2,
                37: 3,
                75: 0,
                76: 1,
                74: 2,
                72: 3,
                87: 0,
                68: 1,
                83: 2,
                65: 3 }
        };
    },

    components: {
        row: __WEBPACK_IMPORTED_MODULE_0__row___default.a
    },
    created: function created() {
        console.log(this.moveAndMerge([4, 4, 4, 0], false));
        for (var i = 0; i < 4; i++) {
            this.tiles[i] = [];
            for (var j = 0; j < 4; j++) {
                this.tiles[i][j] = null;
            }
        }
        this.gameInit(4);
    },
    mounted: function mounted() {
        var self = this;
        document.addEventListener('keydown', function (e) {
            var directioncode = self.map[e.which];
            self.move(directioncode);
        });
    },
    beforeUpdate: function beforeUpdate() {
        if (this.moved && !this.over) {
            this.generateNewTile();
            var that = this;
            setTimeout(that.$forceUpdate, 2000);
            this.moved = false;
        }
    },


    methods: {
        gameInit: function gameInit(size) {
            for (var i = 0; i < size; i++) {
                var positionX = Math.floor(4 * Math.random());
                var positionY = Math.floor(4 * Math.random());
                this.tiles[positionX][positionY] = this.randomNumber();
            }
        },
        randomNumber: function randomNumber() {
            return 2 + 2 * Math.round(Math.random());
        },
        move: function move(directionCode) {
            var newTiles = [];
            var newColumnTiles = [];
            switch (directionCode) {
                case 3:
                    {
                        for (var _x = 0; _x < 4; _x++) {
                            newTiles.push(this.moveAndMerge(this.tiles[_x], false));
                        }
                        break;
                    }
                case 2:
                    {
                        for (var y = 0; y < 4; y++) {
                            var column = [];
                            for (var x = 0; x < 4; x++) {
                                column.push(this.tiles[x][y]);
                            }
                            newColumnTiles.push(this.moveAndMerge(column, true));
                        }

                        for (var ny = 0; ny < 4; ny++) {
                            var _row = [];
                            for (var nx = 0; nx < 4; nx++) {

                                _row.push(newColumnTiles[nx][ny]);
                            }
                            newTiles.push(_row);
                        }
                        break;
                    }
                case 1:
                    {
                        for (var i = 0; i < 4; i++) {
                            newTiles.push(this.moveAndMerge(this.tiles[i], true));
                        }
                        break;
                    }
                case 0:
                    {
                        for (var _y = 0; _y < 4; _y++) {
                            var column = [];
                            for (var x = 0; x < 4; x++) {
                                column.push(this.tiles[x][_y]);
                            }
                            newColumnTiles.push(this.moveAndMerge(column, false));
                        }

                        for (var _ny = 0; _ny < 4; _ny++) {
                            var _row2 = [];
                            for (var _nx = 0; _nx < 4; _nx++) {
                                _row2.push(newColumnTiles[_nx][_ny]);
                            }
                            newTiles.push(_row2);
                        }
                        break;
                    }
            }
            for (var _x2 = 0; _x2 < 4; _x2++) {
                for (var _y2 = 0; _y2 < 4; _y2++) {
                    if (newTiles[_x2][_y2] != this.tiles[_x2][_y2]) {
                        this.moved = true;
                    }
                }
            }
            this.oldTiles = this.tiles;
            this.tiles = newTiles;
            newTiles = [];
        },
        moveAndMerge: function moveAndMerge(list) {
            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            var length = 4;

            var n = reverse ? length - 1 : 0;
            var nList = new Array(length).fill(null);
            var isMerged = false;
            if (!reverse) {
                for (var x = 0; x < length; x++) {
                    if (list[x] !== null) {
                        if (+list[x] == +nList[n - 1] && !isMerged) {
                            nList[n - 1] *= 2;
                            this.$store.commit("addScore", nList[n - 1]);
                            isMerged = true;
                        } else {
                            nList[n++] = +list[x];
                        }
                    }
                }
            } else {
                for (var x = length - 1; x > -1; x--) {
                    if (list[x] !== null) {
                        if (list[x] == nList[n + 1] && !isMerged) {
                            nList[n + 1] *= 2;
                            isMerged = true;
                            this.$store.commit("addScore", nList[n + 1]);
                        } else {
                            nList[n--] = +list[x];
                        }
                    }
                }
            }
            return nList;
        },
        generateNewTile: function generateNewTile() {
            var row, column;

            function haveSpace(tiles) {
                return tiles.some(function (row) {
                    return row.some(function (tile) {
                        return tile == null;
                    });
                });
            };
            if (haveSpace(this.tiles)) {
                do {
                    row = Math.floor(4 * Math.random());
                    column = Math.floor(4 * Math.random());
                } while (this.tiles[row][column] !== null);
                this.tiles[row][column] = Math.random() > 0.5 ? '2' : '4';
            } else {
                this.over = true;
            }
        }
    },
    watch: {
        over: function over() {
            alert('哈哈，挂了吧');
        }
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tile__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tile__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            colormap: {
                2: "#eee4da",
                4: "#ede0c8",
                8: "#f2b179",
                16: '#f59563',
                32: '#f67c5f',
                64: '#f65e3b',
                128: '#edcf72',
                256: '#edcc61',
                512: '#edc850',
                1024: '#edc53f',
                2048: '#edc22e',
                4096: '#3c3a32',
                8192: '#3c3a32'
            }
        };
    },

    props: {
        row: null
    },
    components: { tile: __WEBPACK_IMPORTED_MODULE_0__tile___default.a }

});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            merged: false,
            colormap: {
                2: "#eee4da",
                4: "#ede0c8",
                8: "#f2b179",
                16: '#f59563',
                32: '#f67c5f',
                64: '#f65e3b',
                128: '#edcf72',
                256: '#edcc61',
                512: '#edc850',
                1024: '#edc53f',
                2048: '#edc22e',
                4096: '#3c3a32',
                8192: '#3c3a32'
            }
        };
    },

    props: ['tile'],
    computed: {
        style: function style() {
            return {
                backgroundColor: this.colormap[this.tile],
                color: this.tile > 4 ? '#f9f6f2' : '#333',
                fontSize: this.tile > 1000 ? '36px' : '48px'
            };
        }
    },
    watch: {
        tile: function tile(now, prev) {
            var _this = this;

            if (now && prev && now !== prev) {
                this.merged = true;
                setTimeout(function () {
                    return _this.merged = false;
                }, 100);
            }
        }
    }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            addScore: 0
        };
    },

    computed: {
        score: function score() {
            return this.$store.state.score;
        },
        bestScore: function bestScore() {
            return this.$store.state.bestScore;
        }
    },
    watch: {
        score: function score(now, prev) {
            var _this = this;

            console.log(this.$refs.pplus);
            clearTimeout(this.timer);
            this.addScore = now - prev;
            this.timer = setTimeout(function () {
                return _this.addScore = 0;
            }, 1000);
        }
    }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(3);




var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a }
});
window.onload = function () {
    app.$store.dispatch('init');
};
window.onbeforeunload = function () {
    app.$store.dispatch('save');
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(21)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(37),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(23)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(39),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(38),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(20)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  "data-v-0b6b2a5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile",
    class: {
      'new': typeof _vm.tile === 'string', 'merged': _vm.merged
    },
    style: (_vm.style)
  }, [_vm._v("\r\n" + _vm._s(_vm.tile ? _vm.tile : '') + "\r\n")])
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gamehead"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("2048")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "score"
  }, [_c('span', {
    staticClass: "type"
  }, [_vm._v("score")]), _vm._v(" " + _vm._s(_vm.score) + "\n    "), _c('span', {
    ref: "plus",
    class: {
      'addScore': _vm.addScore
    },
    staticStyle: {
      "position": "absolute",
      "right": "30px",
      "opacity": "0",
      "color": "#444",
      "font-size": "16px"
    }
  }, [_vm._v("+" + _vm._s(_vm.addScore))])]), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_c('span', {
    staticClass: "type"
  }, [_vm._v("best")]), _vm._v(" " + _vm._s(_vm.bestScore))])])])
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('gamehead'), _vm._v(" "), _c('gamecontainer')], 1)
},staticRenderFns: []}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.row), function(tile, index) {
    return _c('tile', {
      key: index,
      attrs: {
        "tile": tile
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.cells), function(cell) {
    return _c('div', {
      key: cell,
      staticClass: "cell"
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiles",
    on: {
      "keydown": _vm.move
    }
  }, _vm._l((_vm.tiles), function(row, index) {
    return _c('row', {
      key: index,
      staticClass: "row",
      attrs: {
        "row": row,
        "from": -2
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-container"
  }, [_c('grid'), _vm._v(" "), _c('tiles')], 1)
},staticRenderFns: []}

/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.1bb0d8c28f9b0a5b47b5.js